import axios from 'axios';

import {
  GET_CUSTOMERS_DETAILS,
  GET_CUSTOMERS_ORDERS,
  GET_CUSTOMERS_ORDER_DETAILS,
  GET_CUSTOMERS_PERSONAL,
  GET_CUSTOMERS_TEAM,
  GET_USER_SETTINGS_FAIL,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  MTB_ADD_DIRECT_BREADCRUMBS,
  MTB_ADD_NEW_MEMBER_MODAL,
  MTB_CLEAR_DIRECT_BREADCRUMBS,
  MTB_GET_BOTTOM_TEAM_MEMBER,
  MTB_GET_DIRECT_LEG_USERS,
  MTB_GET_DIRECT_MEMBERS,
  MTB_GET_ROOT_TEAM_MEMBER,
  MTB_INIT,
  MTB_LEVELS,
  MTB_POP_DIRECT_BREADCRUMB,
  MTB_UNILEVEL,
  MTB_VOLUME,
  StructureType,
  UPDATE_USER_SETTINGS_FAIL,
  UPDATE_USER_SETTINGS_REQUEST,
  UPDATE_USER_SETTINGS_SUCCESS
} from './myTeamBackOffice.constants';
import {
  getBottomTeamMemberAsync,
  getBottomTeamMemberTradingAsync,
  getCustomerDetailsAsync,
  getCustomerOrderDetailsAsync,
  getCustomersOrderAsync,
  getCustomersPersonalAsync,
  getCustomersTeamAsync,
  getDirectMembersAsync,
  getDirectTeamLegUsersAsync,
  getLevelsAsync,
  getRootTeamMemberAsync,
  getRootTeamMemberTradingAsync,
  getVolumesAsync,
  unilevelAsync
} from './myTeamBackOffice.requests';
import { tryExecuteSimpleAction } from '../../helpers/helperFunctions';
import { changeTeamSettings } from '../../slices/settings-slice';

export const init = () => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_INIT.REQUEST,
    async () => {
      const { data: teamMemberResponse } = await getRootTeamMemberAsync();
      const { data: teamMemberTradingResponse } =
        await getRootTeamMemberTradingAsync();

      dispatch({
        type: MTB_INIT.SUCCESS,
        payload: {
          rootTeamMemberTrading: teamMemberTradingResponse.data.teamUser,
          rootTeamMemberInfoTrading: teamMemberTradingResponse.data.user,
          rootTeamMember: teamMemberResponse.data.teamUser,
          rootTeamMemberInfo: teamMemberResponse.data.user,
          userAsTeamMember: teamMemberResponse.data.teamUser,
          userAsTeamMemberInfo: teamMemberResponse.data.user,
          teamUser: teamMemberResponse.data.teamUser
        }
      });
    },
    MTB_INIT.FAIL
  );
};

export const getRootTeamMember = (id, type) => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_GET_ROOT_TEAM_MEMBER.REQUEST,
    async () => {
      if (type === StructureType.TEAM) {
        const { data: teamMemberResponse } = await getRootTeamMemberAsync(id);

        dispatch({
          type: MTB_GET_ROOT_TEAM_MEMBER.SUCCESS,
          payload: {
            rootTeamMember: teamMemberResponse.data.teamUser,
            rootTeamMemberInfo: teamMemberResponse.data.user
          }
        });
      } else if (type === StructureType.TRADING) {
        const { data: teamMemberTradingResponse } =
          await getRootTeamMemberTradingAsync(id);
        dispatch({
          type: MTB_GET_ROOT_TEAM_MEMBER.SUCCESS,
          payload: {
            rootTeamMemberTrading: teamMemberTradingResponse.data.teamUser,
            rootTeamMemberInfoTrading: teamMemberTradingResponse.data.user
          }
        });
      }
    },
    MTB_GET_ROOT_TEAM_MEMBER.FAIL
  );
};

export const getBottomTeamMember = (position, type) => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_GET_BOTTOM_TEAM_MEMBER.REQUEST,
    async () => {
      if (type === StructureType.TEAM) {
        const { data: teamMemberResponse } = await getBottomTeamMemberAsync(
          position
        );

        dispatch({
          type: MTB_GET_BOTTOM_TEAM_MEMBER.SUCCESS,
          payload: {
            rootTeamMember: teamMemberResponse.data.teamUser,
            rootTeamMemberInfo: teamMemberResponse.data.user
          }
        });
      } else if (type === StructureType.TRADING) {
        const { data: teamMemberTradingResponse } =
          await getBottomTeamMemberTradingAsync(position);
        dispatch({
          type: MTB_GET_BOTTOM_TEAM_MEMBER.SUCCESS,
          payload: {
            rootTeamMemberTrading: teamMemberTradingResponse.data.teamUser,
            rootTeamMemberInfoTrading: teamMemberTradingResponse.data.user
          }
        });
      }
    },
    MTB_GET_BOTTOM_TEAM_MEMBER.FAIL
  );
};

export const getVolume = () => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_VOLUME.REQUEST,
    async () => {
      const { data: volumeData } = await getVolumesAsync();

      dispatch({
        type: MTB_VOLUME.SUCCESS,
        payload: {
          volumeInfo: volumeData.data
        }
      });
    },
    MTB_VOLUME.FAIL
  );
};

export const getLevels = () => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_LEVELS.REQUEST,
    async () => {
      const { data: teamLevelsResponse } = await getLevelsAsync();

      dispatch({
        type: MTB_LEVELS.SUCCESS,
        payload: {
          levels: teamLevelsResponse.data.levels
        }
      });
    },
    MTB_LEVELS.FAIL
  );
};

export const getUnilevel = () => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    MTB_UNILEVEL.REQUEST,
    async () => {
      const { data: unilevelData } = await unilevelAsync();

      dispatch({
        type: MTB_UNILEVEL.SUCCESS,
        payload: {
          unilevel: unilevelData.data
        }
      });
    },
    MTB_UNILEVEL.FAIL
  );
};

export const getDirectMembers =
  (id = null, countPerPage) =>
  async (dispatch) => {
    await tryExecuteSimpleAction(
      dispatch,
      MTB_GET_DIRECT_MEMBERS.REQUEST,
      async () => {
        const { data } = await getDirectMembersAsync(id, countPerPage);

        dispatch({
          type: MTB_GET_DIRECT_MEMBERS.SUCCESS,
          payload: {
            leftDirectUsers: data.data.leftDirectUsers,
            rightDirectUsers: data.data.rightDirectUsers,
            directTeamMember: data.data.user,
            directTeamMemberInfo: data.data.userInfo
          }
        });
      },
      MTB_GET_DIRECT_MEMBERS.FAIL
    );
  };

export const getDirectTeamLegUsers =
  (id = null, numberOfPage, countPerPage, leg) =>
  async (dispatch) => {
    try {
      dispatch({ type: MTB_GET_DIRECT_LEG_USERS.REQUEST, payload: leg });

      const { data } = await getDirectTeamLegUsersAsync(
        id,
        numberOfPage,
        countPerPage,
        leg
      );

      dispatch({
        type: MTB_GET_DIRECT_LEG_USERS.SUCCESS,
        payload: {
          directUsers: data.data.directUsers,
          leg
        }
      });
    } catch (error) {
      dispatch({
        type: MTB_GET_DIRECT_LEG_USERS.FAIL,
        payload: error.response && error.response.data
      });
    }
  };

export const directGoBack = () => async (dispatch, getState) => {
  const { directBreadcrumbs } = getState().myTeamBackoffice;
  const id = directBreadcrumbs[directBreadcrumbs.length - 2];

  dispatch(getDirectMembers(id, 20));
  dispatch({
    type: MTB_POP_DIRECT_BREADCRUMB
  });
};

export const openAddNewMemberModal =
  (parentId, position) => async (dispatch) => {
    dispatch({
      type: MTB_ADD_NEW_MEMBER_MODAL.OPEN,
      payload: { parentId, position }
    });
  };

export const closeAddNewMemberModal = () => async (dispatch) => {
  dispatch({
    type: MTB_ADD_NEW_MEMBER_MODAL.CLOSE
  });
};

export const clearBreadCrumbs = () => async (dispatch) => {
  dispatch({
    type: MTB_CLEAR_DIRECT_BREADCRUMBS
  });
};

export const addDirectBreadCrumb = (id) => async (dispatch) => {
  dispatch({
    type: MTB_ADD_DIRECT_BREADCRUMBS,
    payload: id
  });
};

export const getCustomersPersonal =
  (keyword, numberOfPage, countPerPage) => async (dispatch) => {
    await tryExecuteSimpleAction(
      dispatch,
      GET_CUSTOMERS_PERSONAL.REQUEST,
      async () => {
        const { data } = await getCustomersPersonalAsync(
          numberOfPage,
          countPerPage,
          keyword
        );

        dispatch({
          type: GET_CUSTOMERS_PERSONAL.SUCCESS,
          payload: data.data.personalUsers
        });
      },
      GET_CUSTOMERS_PERSONAL
    );
  };

export const getCustomersTeam =
  (keyword, numberOfPage, countPerPage) => async (dispatch) => {
    await tryExecuteSimpleAction(
      dispatch,
      GET_CUSTOMERS_TEAM.REQUEST,
      async () => {
        const { data } = await getCustomersTeamAsync(
          numberOfPage,
          countPerPage,
          keyword
        );

        dispatch({
          type: GET_CUSTOMERS_TEAM.SUCCESS,
          payload: data.data.teamUsers
        });
      },
      GET_CUSTOMERS_TEAM
    );
  };

export const getCustomersOrder =
  (keyword, numberOfPage, countPerPage) => async (dispatch) => {
    await tryExecuteSimpleAction(
      dispatch,
      GET_CUSTOMERS_ORDERS.REQUEST,
      async () => {
        const { data } = await getCustomersOrderAsync(
          numberOfPage,
          countPerPage,
          keyword
        );

        dispatch({
          type: GET_CUSTOMERS_ORDERS.SUCCESS,
          payload: data.data.orders
        });
      },
      GET_CUSTOMERS_ORDERS
    );
  };

export const getCustomerDetails = (id) => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    GET_CUSTOMERS_DETAILS.REQUEST,
    async () => {
      const { data } = await getCustomerDetailsAsync(id);

      dispatch({
        type: GET_CUSTOMERS_DETAILS.SUCCESS,
        payload: data.data
      });
    },
    GET_CUSTOMERS_DETAILS
  );
};

export const getCustomerOrderDetails = (id) => async (dispatch) => {
  await tryExecuteSimpleAction(
    dispatch,
    GET_CUSTOMERS_ORDER_DETAILS.REQUEST,
    async () => {
      const { data } = await getCustomerOrderDetailsAsync(id);

      dispatch({
        type: GET_CUSTOMERS_ORDER_DETAILS.SUCCESS,
        payload: data.data.order
      });
    },
    GET_CUSTOMERS_ORDER_DETAILS
  );
};

export const getUserSettings = () => async (dispatch, getState) => {
  await tryExecuteSimpleAction(
    dispatch,
    GET_USER_SETTINGS_REQUEST,
    async () => {
      const { data } = await axios.get(`/user/settings`);

      dispatch({
        type: GET_USER_SETTINGS_SUCCESS,
        payload: data.data.settings
      });

      dispatch(changeTeamSettings(data.data.settings.teamCompletionSorting));
    },
    GET_USER_SETTINGS_FAIL
  );
};

export const updateTeamCompletionSorting =
  (teamCompletionSorting) => async (dispatch) => {
    await tryExecuteSimpleAction(
      dispatch,
      UPDATE_USER_SETTINGS_REQUEST,
      async () => {
        const { data } = await axios.put(`/user/settings`, {
          teamCompletionSorting
        });

        dispatch({
          type: UPDATE_USER_SETTINGS_SUCCESS,
          payload: data.data.settings
        });

        dispatch(changeTeamSettings(data.data.settings.teamCompletionSorting));

        // SuccessToast();
      },
      UPDATE_USER_SETTINGS_FAIL
    );
  };
